exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".standout[data-v-00736e42]{font-weight:700;color:#444}.description[data-v-00736e42]{font-style:italic;font-size:12px;word-break:break-word;color:#888}.not-final[data-v-00736e42]{font-size:20px;font-weight:700;color:#909399}.printable-title.top[data-v-00736e42]{margin-top:0}.standout-accent[data-v-00736e42]{color:#dd711f}.serves[data-v-00736e42]{color:#444}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-00736e42","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?indentedSyntax!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/print/EstimatePDF.vue
// module id = 479
// module chunks = 0